import { Component, OnInit } from '@angular/core';
// import { SocketService } from '../socket.service';
import { EcachatRoomService } from './ecachatroom.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ecachatroom',
  templateUrl: './ecachatroom.component.html',
  styleUrls: ['./ecachatroom.component.css']
})
export class EcachatroomComponent implements OnInit {

  sessionIdSubscription: Subscription;
  sessionId="";

  constructor(
    private chatRoomService:EcachatRoomService,
    // private SocketService:SocketService,
  ) { }



  ngOnInit(): void {
    // this.sessionIdSubscription = this.SocketService.sessionId.subscribe(sessionId => {
    //   this.sessionId=sessionId;
    //   this.particpantList();
    // });
  }


  particpantList(){
    this.chatRoomService.participantList({sessionId:this.sessionId}).subscribe((data)=>{
      console.log("particpant list",data);
    })
  }
}
